module.exports = __webpack_public_path__ + "static/media/Aamer_profile_pic (1).ecd01e21.jpg";